// src/utils/fetchUserQuestions.js
export async function getAdminQustions({ currentTheme, token, organizationId, sessionId }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/getAdminQuestions`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization:  `Bearer ${token}`,
    },
    body: JSON.stringify({ currentTheme, organizationId, sessionId }),
  });

  if (!resp.ok) {
    const err = await resp.json();
    throw new Error(err.message || 'Failed to fetch user questions');
  }
  return resp.json(); // { allQuestions, lifelines, points }
}
